import { FILE_SIZE_LIMIT } from "./constants";

export const isFileSizeExceedsLimit = (files = []) => {
  return files.some(file => (file.size / (1024 * 1024)).toFixed(2) > FILE_SIZE_LIMIT);
};
